import React, { Fragment } from "react";
const GetCanonicalPath = await import("@asyncImports/GetCanonicalPath.js").then(
  (mod) => mod.GetCanonicalPath,
);
const CleanUrl = await import("@asyncImports/CleanUrl.js").then(
  (mod) => mod.CleanUrl,
);
export const CanonicalUrl = ({ urlParam, canonicalParam }) => {
  urlParam = CleanUrl(urlParam);
  canonicalParam = GetCanonicalPath(CleanUrl(canonicalParam ?? urlParam)).join(
    "/",
  );
  if (urlParam !== canonicalParam) {
    return <link rel="canonical" href={canonicalParam} />;
  }
  return <Fragment />;
};
